import axios from 'axios';
import React, { Component } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import AssignmentOutlinedIcon from '@material-ui/icons/AssignmentOutlined';
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';
import GetAppRoundedIcon from '@material-ui/icons/GetAppRounded';

import FormUpdateStatus from './FormUpdateStatus';
import {
  apiList,
  dencrypt,
  variables,
  verifyLogin,
  encrypt,
  shortDate,
} from '../../helpers';
import SidePanel from '../../components/SidePanel/SidePanel';
import Loading from '../../components/loading/loading';
import Navbar from '../../components/navBar/navBar';
import ReportFormatPanel from '../../components/ReportFormatPanel/ReportFormatPanel';
import PageContainer from '../../components/PageContainer/PageContainer';
import {
  DetailPageSkeleton, DetailSection, Field, FieldGrid, SectionButton,
} from '../../components/DetailSection/DetailSection';

const successTimeOut = variables.SUCCESS_TIMEOUT;
const errorTimeOut = variables.SUCCUSS_TIMEOUT;

class RequestDetails extends Component {
  constructor() {
    super();
    this.state = {
      result: false,
      comments: '',
      requestStatus: '',
      sectionOne: true,
      data: {},
      dataLoaded: false,
      formOpen: false,
      reportFormatListModal: false,
      permission: {},
    };
  }

  componentDidMount() {
    this.setState({ result: true });
    const { roleMapping, user } = verifyLogin();
    if (user.userRoleId === 1 || user.userRoleId === 2) {
      this.setState({
        permission: {
          view: true, add: true, edit: true, delete: true,
        },
      });
    } else {
      const permission = roleMapping.find((obj) => obj.PermissionConfig?.name === 'Disbursal Requests');
      this.setState({ permission: permission || {} });
    }
    const { session } = verifyLogin();
    const config = { headers: { session, permissionConfig: 'Disbursal Requests', feature: 'view' } };
    const parmasString = dencrypt(this.props.match.params.detailId);
    const params = JSON.parse(parmasString);

    axios.get(`${apiList.VEIW_REQUEST_API}/${params.disRequestID}`, config)
      .then((response) => {
        this.setState({
          data: { ...response.data.data },
          dataLoaded: true,
          comments: response.data.data?.comments,
          requestStatus: response.data.data?.requestStatus,
          result: false,
        });
      })
      .catch((error) => {
        toast.error(`${error.message || error.response.message}`);
        this.setState({ result: false });
      });
  }

  handleChange(key) {
    key.preventDefault();
    this.setState({ [key.target.id]: key.target.value });
  }

  handleSubmitData(key) {
    key.preventDefault();
    const { data, comments, requestStatus } = this.state;

    if (!data && !data.id && data.id.length < 1) {
      toast.error('Something wrong occured, please try again');
      return;
    }

    if ((requestStatus !== 'Open' && requestStatus !== 'Close') || !comments || comments.length < 1) {
      toast.error('All fields are mandatory.');
      return;
    }

    if (requestStatus === '') {
      this.setState({ requestStatus: data.requestStatus });
      return;
    } if (comments === '') {
      this.setState({ comments: data.comments });
      return;
    } if (comments === '') {
      toast.error('Comment field is required');
      return;
    }

    this.setState({ result: true });
    const { session } = verifyLogin();
    const config = { headers: { session, permissionConfig: 'Disbursal Requests', feature: 'edit' } };

    axios.patch(`${apiList.UPDATE_REQUEST_API}/${data.id}`, { comments, requestStatus }, config)
      .then((response) => {
        toast.success(response.data.message);
        this.setState({ data: { ...response.data.data }, dataLoaded: true, formOpen: false });

        setTimeout(() => {
          this.setState({ result: false });
        }, successTimeOut);
      })
      .catch((error) => {
        toast.error(`${error.message || error.response.message}`);

        setTimeout(() => {
          this.setState({ result: false });
        }, errorTimeOut);
      });
  }

  handleSectionOne(key) {
    key.preventDefault();
    const { sectionOne } = this.state;
    this.setState({ sectionOne: !sectionOne });
  }

  handlePDF(id) {
    const dataString = dencrypt(this.props.match.params.detailId);
    const data = JSON.parse(dataString);
    data.docType = 'disbursement';
    data.reportFormatType = id;
    const detailId = encrypt(JSON.stringify(data));
    const redirectUrl = `/document/${detailId}`;
    window.open(redirectUrl, '_blank');
    this.setState({ reportFormatListModal: false });
  }

  getViewLoanUrl() {
    const detailId = encrypt(this.state.data.loanId);
    return `/view-loan-details/${detailId}`;
  }

  body = () => (
    <FormUpdateStatus
      handleChange={(id) => this.handleChange(id)}
      comments={this.state.comments}
      setStatus={(event) => {
        this.setState({ requestStatus: event.target.value });
      }}
      status={this.state.requestStatus}
    />
  )

  // Opens the Change status panel with the request's current values.
  openStatusPanel() {
    const { data } = this.state;
    this.setState({
      formOpen: true,
      requestStatus: data.requestStatus || '',
      comments: data.comments || '',
    });
  }

  render() {
    const {
      result,
      data,
      dataLoaded,
      sectionOne,
      formOpen,
      permission,
      reportFormatListModal,
    } = this.state;

    verifyLogin();
    const loan = data?.Loan;
    const property = loan?.LoanProperty || {};
    const location = [
      [property.addressLine1, property.addressLine2, property.cityTown].filter(Boolean).join(' '),
      property.district,
    ].filter(Boolean).join(', ');
    let statusClass = '';
    if (data.requestStatus === 'Open') statusClass = 'open';
    if (data.requestStatus === 'Close') statusClass = 'closed';

    return (
      <div className='ds-page'>

        {result === true && dataLoaded ? <Loading MainProps={this.props} /> : null}

        <ToastContainer />
        <SidePanel
          open={formOpen}
          setOpen={(value) => this.setState({ formOpen: value })}
          newForm={false}
          body={this.body()}
          handleSaveData={(key) => this.handleSubmitData(key)}
          title='Change status'
          subtitle='Open or close this request and add a comment.'
          actionLabel='Save'
        />

        <ReportFormatPanel
          open={reportFormatListModal}
          type={2}
          title='Download DRF'
          subtitle='Choose a report format for the disbursement request form.'
          actionLabel='Generate report'
          onClose={() => this.setState({ reportFormatListModal: false })}
          onGenerate={(id) => this.handlePDF(id)}
        />

        <Navbar MainProps={this.props} />

        <PageContainer width='narrow' stack className={dataLoaded ? 'ds-loaded' : ''}>
          {!dataLoaded && result ? <DetailPageSkeleton sections={['fields']} /> : null}

          {dataLoaded && loan ? (
            <div className='ds-title'>
              <h1>{`${data.requestType || 'Customer'} request`}</h1>
              <span>{loan.loanNumber || ''}</span>
            </div>
          ) : null}

          {dataLoaded ? (
            <DetailSection
              title='Customer Request Details'
              icon={AssignmentOutlinedIcon}
              open={sectionOne}
              onToggle={(key) => this.handleSectionOne(key)}
              actions={permission.edit ? (
                <>
                  {data.requestStatus === 'Open' ? (
                    <SectionButton
                      icon={GetAppRoundedIcon}
                      onClick={() => this.setState({ reportFormatListModal: true })}
                    >
                      Download DRF
                    </SectionButton>
                  ) : null}
                  <SectionButton
                    primary
                    icon={EditOutlinedIcon}
                    onClick={() => this.openStatusPanel()}
                  >
                    Change Status
                  </SectionButton>
                </>
              ) : null}
            >
              {loan ? (
                <FieldGrid>
                  <Field label='Loan Number'>
                    <a className='ds-link' href={this.getViewLoanUrl()}>
                      {loan.loanNumber || 'N/A'}
                    </a>
                  </Field>
                  <Field label='Customer Name'>{loan.custName || 'N/A'}</Field>
                  <Field label='Request Type'>{data.requestType || 'N/A'}</Field>
                  <Field label='Request Status'>
                    {data.requestStatus
                      ? <span className={`ds-chip ${statusClass}`}>{data.requestStatus}</span>
                      : 'N/A'}
                  </Field>
                  <Field label='Submitted On'>{shortDate(data.createdAt) || 'N/A'}</Field>
                  <Field label='Closed On'>{data.closedDate ? shortDate(data.closedDate) : 'N/A'}</Field>
                  <Field label='Property Location' wide>{location || 'N/A'}</Field>
                  <Field label='Comment'>{data.comments || 'N/A'}</Field>
                </FieldGrid>
              ) : null}
            </DetailSection>
          ) : null}
        </PageContainer>
      </div>
    );
  }
}

export default RequestDetails;
